import moment from 'moment';

export const todaysDate = () => {
    return moment().format("DD-MM-YYYY");
}
export const dateStandardInput = (date) => {
    return moment(date).format("YYYY-MM-DD");
}
export const dateStandard = (date) => {
    return moment(date).format("DD-MM-YYYY");
}

export const dateIndian = (date) => {
    return date ? moment(date).format("DD/MM/YYYY") : "";
}
export const monthIndian = (month) => {
    return month ? moment(month).format("MM/YYYY") : month;
}

export const dateBasicFormant = (date) => {
    var _date = moment(date, "YYYY-MM-DD");

    return _date._d;
}

export const dateTimeBasicFormantOld = (date) => {
    var _date = moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY hh:mmA");
    return _date;
}

export const dateTimeBasicFormantOld530 = (date) => {
    var _date = moment(date, "YYYY-MM-DD HH:mm:ss")
        .utcOffset('+05:30')
        .add(5, 'hours')
        .add(30, 'minutes')
        .format("DD-MM-YYYY hh:mmA");
    return _date;
}

export const dateTimeBasicFormant = (date) => {
    var _date = moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY hh:mmA");
    return _date;
}

export const dateTimeBasicFormant530 = (date) => {
    var _date = moment(date, "YYYY-MM-DD HH:mm:ss")
        .add(5, 'hours')
        .add(30, 'minutes')
        .format("DD-MMM-YYYY hh:mmA");
    return _date;
}

export const dateToISO = (date) => {
    const d = new Date(date);
    return d.toISOString();
}

export const dateUSStandard = (date) => {
    return moment(date).format("MM-DD-YYYY");
}

export const dateSlashFormant = (date) => {
    return moment(date).format("YYYY/MM/DD");
}

export const dateArithmetic = (date, qty) => {
    return moment(date, "YYYY-MM-DD").add(qty, 'days').format("YYYY-MM-DD");
}

export const dateDifference = (start, end) => {
    start = moment(start, "YYYY-MM-DD");
    end = moment(end, "YYYY-MM-DD");
    return end.diff(start, 'days');
}

export const dateMonthFormat = (date) => {
    return moment(date).format("DD MMMM, YYYY");
}

export const changeTzToNormal = (date) => {
    if (date) {
        let sDate = moment(date);
        sDate = sDate.format('DD-MM-YYYY hh:mm A')
        return sDate
    }
    else {
        return ""
    }

}

export const changeTzToNormalDefault = (date) => {
    if (date) {
        let sDate = moment(date);
        sDate = sDate.format('YYYY-MM-DD HH:mm')


        return {
            date: sDate.split(" ")[0],
            time: sDate.split(" ")[1]
        }
    }
    else {
        return {
            date: "",
            time: ""
        }
    }

}

export const singleDate = (date) => {
    return date.date + " " + date.time
}


export const TimeDiff = (startTime, endTime) => {

    var todayDate = moment(new Date()).format("MM-DD-YYYY");
    var startDate = new Date(`${todayDate} ${startTime}`);
    var endDate = new Date(`${todayDate} ${endTime}`);
    var timeDiff = endDate.getTime() - startDate.getTime();
    ;
    if (timeDiff <= 0) {
        var nextDay = moment(new Date()).add(1, 'days').format("MM-DD-YYYY");
        endDate = new Date(`${nextDay} ${endTime}`);
    }

    ;
    timeDiff = endDate.getTime() - startDate.getTime();

    var hh = Math.floor(timeDiff / 1000 / 60 / 60);
    hh = ('0' + hh).slice(-2)

    timeDiff -= hh * 1000 * 60 * 60;
    var mm = Math.floor(timeDiff / 1000 / 60);
    mm = ('0' + mm).slice(-2)

    timeDiff -= mm * 1000 * 60;
    var ss = Math.floor(timeDiff / 1000);
    ss = ('0' + ss).slice(-2)

    return {
        h: hh,
        m: mm
    }
}


//Time
export const changeTime = (time) => {
    let _time = time.split(':');
    return _time[0] + ":" + _time[1];
}

export const timeFormat = (time) => {

    let _time = moment(time, "HH:mm:ss").format("hh:mmA").slice(0, -1);

    return _time
}

export const timeFormatWithoutSeconds = (time) => {
    let _time = moment(time, "HH:mm:ss").format("HH:mm");
    return _time
}


export const timeFormatWithData = (date) => {

    let _time = changeTzToNormal(date);
    ;
    return timeFormat(_time.time + ":00")
}

export const timeFormatFull = (time) => {

    time = time.split("T");
    time = time[1].split(".")

    let _time = moment(time[0], "HH:mm:ss").format("hh:mmA");
    return _time
}

export const dateTimeFormatFull = (time) => {
    try {
        if (time) {
            if (time.indexOf("T") == -1) {
                return {
                    date: dateStandard(time),
                    time: '',
                }
            }
            let date = time.split("T");
            time = date[1].split(".")

            return {
                date: dateStandard(date[0]),
                time: moment(time[0], "HH:mm:ss").format("HH:mm"),
            }
        }
        return {
            date: "",
            time: ""
        }
    } catch (e) {
        return {
            date: "",
            time: ""
        }
    }


}

//week and month
export const weekDate = () => {
    var curr = new Date; // get current date
    var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    var start = dateStandard(new Date(curr.setDate(first)));
    var end = dateStandard(new Date(curr.setDate(last)));
    return {
        start: start,
        end: end,
    }
}

export const monthDate = () => {
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    var lastDay = new Date(y, m + 1, 0);

    return {
        start: dateStandard(firstDay),
        end: dateStandard(lastDay),
    }
}

//compare teo time 
export const compareTwoTime = (start, end) => {
    if (start && end) {
        var beginningTime = moment(start, 'HH:mm');
        var endTime = moment(end, 'HH:mm');
        return beginningTime.isBefore(endTime);
    }
    return false;

}

export const updateShiftHours = (startDate, endDate) => {

    if (endDate.length == 0 || startDate.length == 0) return



    const duration = moment.duration(moment(endDate, 'YYYY-MM-DD hh:mm').diff(moment(startDate, 'YYYY-MM-DD hh:mm')));

    const totalHours = `${parseInt(duration.asHours())}.${parseInt(duration.asMinutes()) % 60}`

    return totalHours

}
export const checkDateValidation = (startDate, endDate) => {
    // check the dates
    if ((new Date(startDate) > new Date(endDate)) || (new Date(endDate) < new Date(startDate))) {
        return true
    } else {
        return false
    }
}
export const dateFormat = (dateStr) => {

    const date = new Date(dateStr);
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ]
    const formattedDate = `${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}`;

    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours %= 12;
    hours = hours || 12; // Handle midnight (12:00 AM)
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedTime = `${hours}:${minutes} ${ampm}`;

    return formattedDate + ", " + formattedTime
}
export const dateFormatWith530 = (dateStr) => {
    const date = new Date(dateStr);

    // Add 5 hours and 30 minutes
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);

    if (date.getHours() >= 24) {
        date.setDate(date.getDate() + 1);
        date.setHours(date.getHours() - 24);
    }

    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const formattedDate = `${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}`;

    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours %= 12;
    hours = hours || 12; // Handle midnight (12:00 AM)
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedTime = `${hours}:${minutes} ${ampm}`;

    return formattedDate + ", " + formattedTime;
};




export const formatDateMonthName = (inputDate) => {
    if (!moment(inputDate).isValid()) {
        return "Invalid date format";
    }
    const originalDate = moment(inputDate);
    const formattedDate = originalDate.format("Do MMMM YYYY");
    return formattedDate;
}

export const formatUTCtoUTCDateMnameYearTime = (meetingTime) => {

    if (!meetingTime) {
        return '';
    }
    // #EXAMPLE "2023-11-17T10:00:00Z" TO 17 Nov 23, 10:00AM
    const localMeetingTime = moment.utc(meetingTime);
    return localMeetingTime.format("DD MMM YY, hh:mmA");
};

export const dateFormatUTCtoLocal = (dateStr) => {

    // GMT TO Example: "16 Dec 23, 04:00PM"
    const date = moment(dateStr);

    const formattedDate = date.format('DD MMM YY, hh:mmA');

    return formattedDate;
};

/**
 * Calculates the time difference between two UTC dates.
 *
 * @param {string} startTime - The starting UTC date and time.
 * @param {string} endTime - The ending UTC date and time.
 * @returns {Object} An object containing the time difference information.
 * @property {string} humanized - A human-readable representation of the time difference.
 * @property {number} hours - The time difference in hours.
 * @property {number} minutes - The time difference in minutes.
 * @property {number} seconds - The time difference in seconds.
 * @property {boolean} isExpired - Indicates whether the end time is after the start time.
 * @property {boolean} isReadyToStart - Indicates whether the time difference is between 0 and 6 hours.

 */

export const getTimeDifference = (startTime, endTime = new Date().toLocaleString(), activeHour = 6) => {
    const startMoment = moment.utc(startTime);
    const endMoment = moment.utc();
    const duration = moment.duration(startMoment.diff(endMoment));
    const isExpired = endMoment.isAfter(startMoment);
    const isReadyToStart = duration.asHours() >= 0 && duration.asHours() <= activeHour;

    return {
        humanized: duration.humanize(),
        hours: duration.asHours(),
        minutes: duration.asMinutes(),
        seconds: duration.asSeconds(),
        isExpired,
        isReadyToStart,
    };
};

export const calculateTimeDifference = (givenTimeStr) => {
    const givenTime = moment(givenTimeStr);
    const currentTime = moment().add(5, 'hours').add(30, 'minutes');

    const diffInSeconds = currentTime.diff(givenTime, 'seconds');

    const humanized = diffInSeconds < 0
        ? `in ${Math.abs(diffInSeconds)} seconds`
        : diffInSeconds < 60
            ? diffInSeconds === 1 ? '1 second ago' : `${diffInSeconds} seconds ago`
            : diffInSeconds < 3600
                ? diffInSeconds / 60 < 2 ? '1 minute ago' : `${Math.floor(diffInSeconds / 60)} minutes ago`
                : diffInSeconds < 86400
                    ? diffInSeconds / 3600 < 2 ? '1 hour ago' : `${Math.floor(diffInSeconds / 3600)} hours ago`
                    : `${Math.floor(diffInSeconds / 86400)} days ago`;

    const fullTimeDiff = diffInSeconds < 0
        ? `in ${Math.abs(Math.floor(diffInSeconds / 3600))} hours and ${Math.abs(diffInSeconds % 3600)} seconds`
        : diffInSeconds < 3600
            ? `${Math.floor(diffInSeconds / 60)} minutes and ${diffInSeconds % 60} seconds`
            : `${Math.floor(diffInSeconds / 86400)} days ${Math.floor((diffInSeconds % 86400) / 3600)} hours and ${diffInSeconds % 3600} seconds`;

    const improvedFullTimeDiff = diffInSeconds < 0
        ? `in ${Math.abs(Math.floor(diffInSeconds / 3600))} hours and ${Math.abs(diffInSeconds % 3600)} seconds`
        : diffInSeconds < 3600
            ? `${Math.floor(diffInSeconds / 60)} minutes and ${diffInSeconds % 60} seconds`
            : `${Math.floor(diffInSeconds / 86400)} days ${Math.floor((diffInSeconds % 86400) / 3600) > 0 ? ' ' + Math.floor((diffInSeconds % 86400) / 3600) + ' hours' : ''} ${diffInSeconds % 3600 > 0 ? ' ' + diffInSeconds % 3600 + ' seconds' : ''}`;

    return {
        humanized,
        fullTimeDiff,
        improvedFullTimeDiff,
        seconds: diffInSeconds,
        minutes: Math.floor(diffInSeconds / 60),
        hours: Math.floor(diffInSeconds / 3600),
        days: Math.floor(diffInSeconds / 86400),
        isExpired: currentTime.isAfter(givenTime),
        isReadyToStart: currentTime.isSameOrAfter(givenTime)
    };
};

export const dateFormatLocaleTLocale = (inputDate) => {
    // inputDate: '12/15/2023, 3:02:14 PM'
    // newDate: '15 Dec 23, 3:02PM'
    if (!inputDate) {
        return null
    }

    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const [datePart, timePart] = inputDate.split(', ');
    const [month, day, year] = datePart.split('/');
    const [hours, minutes, seconds] = timePart.replace(/(AM|PM)/, '').split(':');
    const newDate = `${parseInt(day)} ${months[parseInt(month) - 1]} ${year.slice(-2)}, ${hours}:${minutes}${timePart.includes('AM') ? 'AM' : 'PM'}`;
    return newDate;
};


export const getTimeDifferenceInDayHrMin = (updatedAt) => {
    const now = moment();
    const updatedAtMoment = moment(updatedAt);

    const duration = moment.duration(now.diff(updatedAtMoment));

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();

    let timeDiffStr = '';
    if (days > 0) {
        timeDiffStr += `${days} day `;
    }
    if (hours > 0) {
        timeDiffStr += `${hours} hr `;
    }
    if (minutes > 0) {
        timeDiffStr += `${minutes} min`;
    }
    if (timeDiffStr === '') {
        timeDiffStr = 'less than a minute';
    }

    return timeDiffStr;
}

export const formatDateAndTimeSlotToRequestForTime = (date, time) => {
    // Handle null or undefined values for date
    if (!date || !date.date || !date.month || !date.year) {
        return '';
    }

    // Handle null or undefined time
    if (!time || typeof time !== 'string' || !time.includes(' ')) {
        return '';
    }

    // Format the date
    const formattedDate = `${date.date} ${new Date(date.year, date.month - 1).toLocaleString('en-US', { month: 'short' })} ${date.year.toString().slice(-2)}`;

    // Extract and format the time
    const formattedTime = time.split(' ')[0] + time.split(' ')[1];

    // Return formatted date and time
    return `${formattedDate}, ${formattedTime}`;
};


export const formatDateRange = (startDateStr, endDateStr) => {

    // const startDate = "2024-09-04T00:00:00.000Z";
    // const endDate = "2024-09-04T23:59:59.000Z";
    // OUTPUT 
    // 04 Sept - 08 Sept 24
    // 28 Aug - 04 Sept 24
    // 28 Dec 24 - 02 Jan 25

    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    const startDay = startDate.toLocaleDateString('en-GB', { day: '2-digit' });
    const startMonth = startDate.toLocaleDateString('en-GB', { month: 'short' });
    const endDay = endDate.toLocaleDateString('en-GB', { day: '2-digit' });
    const endMonth = endDate.toLocaleDateString('en-GB', { month: 'short' });

    const startYear = startDate.getFullYear().toString().slice(-2); // Get last two digits of the year
    const endYear = endDate.getFullYear().toString().slice(-2); // Get last two digits of the year

    // If the month and year are the same for both dates
    if (startMonth === endMonth) {
        return `${startDay} ${startMonth} - ${endDay} ${startMonth} '${startYear}`;
    }

    // If only the year is the same for both dates
    if (startYear === endYear) {
        return `${startDay} ${startMonth} - ${endDay} ${endMonth} '${startYear}`;
    }

    // If the year is different
    return `${startDay} ${startMonth} '${startYear} - ${endDay} ${endMonth} '${endYear}`;
};

export const DateRangeComponent = ({ startDateStr, endDateStr }) => {
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.toLocaleDateString('en-GB', { day: '2-digit' });
        const month = date.toLocaleDateString('en-GB', { month: 'short' });
        const year = date.getFullYear().toString().slice(-2);
        return `${day} ${month} '${year}`;
    };

    const startDateFormatted = formatDate(startDateStr);
    const endDateFormatted = formatDate(endDateStr);

    return (
        <div>
            <p>Start Date: {startDateFormatted}</p>
            <p>End Date: {endDateFormatted}</p>
        </div>
    );
};


export const addFiveThirty = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    // Add 5 hours and 30 minutes
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    return date.toISOString();
}

export const removeFiveThirty = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    // Subtract 5 hours and 30 minutes
    date.setHours(date.getHours() - 5);
    date.setMinutes(date.getMinutes() - 30);
    return date.toISOString();
}
